import React, { useState } from "react";
import Button from "../../../../components/Button";
import ComplaintAdditionService from "../../../../services/ComplaintAddition";
import { toast } from "react-toastify";

function TableFormNewField({ getNewDataAdd, addNewWorker, startDate, endDate }) {
  const baseHeight = 40;
  const dynamicHeight = baseHeight;
  const dynamicStyle = {
    minHeight: `${dynamicHeight}px`,
    maxHeight: `${dynamicHeight}px`,
    height: `${dynamicHeight}px`,
  };

  const widthStyle = {
    no: {
      width: "80px",
      minWidth: "80px",
      maxWidth: "80px",
      flexShrink: "0",
      position: "sticky",
      left: "0",
      backgroundColor: "#f8f8f8",
    },
    worker_id: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      left: "80px",
      backgroundColor: "#f8f8f8",
    },
    worker_name: {
      width: "200px",
      minWidth: "200px",
      maxWidth: "200px",
      flexShrink: "0",
      position: "sticky",
      left: "215px",
      backgroundColor: "#f8f8f8",
    },
    worker_type: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    initial_amount: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    project_id: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    amount_complain: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    final_amount: { width: "100%", minWidth: "300px", maxWidth: "100%", backgroundColor: "#f8f8f8" },
    action: {
      width: "135px",
      minWidth: "135px",
      maxWidth: "135px",
      flexShrink: "0",
      position: "sticky",
      right: "0",
      backgroundColor: "#f8f8f8",
    },
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0,
    }).format(value || 0);

  const [formData, setFormData] = useState({
    start_date: startDate,
    end_date: endDate,
    project_id: "",
    worker_id: "",
    amount: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: field === "amount" ? Number(value.replace(/[^\d]/g, "")) || 0 : value,
    }));
  };

  const handleAdd = async () => {
    try {
      if (!formData.project_id || !formData.worker_id || !formData.amount) {
        toast.warning("Semua field wajib diisi!");
        return;
      }

      const payload = {
        ...formData,
        project_id: Number(formData.project_id),
        worker_id: Number(formData.worker_id),
        amount: Number(formData.amount),
      };

      await ComplaintAdditionService.add(payload);

      toast.success("Data berhasil ditambahkan!");
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Error adding data");
    } finally {
      getNewDataAdd();
      addNewWorker(false);
      setFormData({
        start_date: null,
        end_date: null,
        project_id: null,
        worker_id: null,
        amount: null,
      });
    }
  };

  return (
    <>
      {/* No */}
      <div
        className="flex justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.no, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className="m-0 p-0 fw-bold text-xs">-</h6>
        </div>
      </div>

      {/* Worker ID */}
      <div
        className="flex justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.worker_id, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <input
            type="text"
            placeholder="Worker Id"
            value={formData.worker_id}
            onChange={(e) => handleChange("worker_id", e.target.value)}
            className="form-control text-xs fw-bold"
            style={{ height: "35px", maxWidth: "80%", padding: "0 0", background: "transparent", border: "none" }}
          />
        </div>
      </div>

      {/* Worker Name */}
      <div
        className="flex justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.worker_name, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className="m-0 p-0 fw-bold text-xs">-</h6>
        </div>
      </div>

      {/* Worker Type */}
      <div
        className="flex justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.worker_type, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className="m-0 p-0 fw-bold text-xs">-</h6>
        </div>
      </div>

      {/* Amount */}
      <div
        className="flex justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.initial_amount, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className="m-0 p-0 fw-bold text-xs">-</h6>
        </div>
      </div>

      {/* Project ID */}
      <div
        className="flex justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.project_id, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <input
            type="text"
            placeholder="Project Id"
            value={formData.project_id}
            onChange={(e) => handleChange("project_id", e.target.value)}
            className="form-control text-xs fw-bold"
            style={{ height: "35px", maxWidth: "80%", padding: "0 0", background: "transparent", border: "none" }}
          />
        </div>
      </div>

      {/* Amount Complain */}
      <div
        className="flex justify-content-center align-items-center border-right-1 border-200"
        style={{ ...widthStyle.amount_complain, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <input
            type="text"
            autoFocus
            placeholder="Amount Complain"
            value={formatCurrency(formData.amount)}
            onChange={(e) => handleChange("amount", e.target.value)}
            className="form-control text-xs fw-bold"
            style={{ height: "35px", maxWidth: "80%", padding: "0 0", background: "transparent", border: "none" }}
          />
        </div>
      </div>

      {/* Final Amount */}
      <div
        className="flex justify-content-center align-items-center"
        style={{ ...widthStyle.final_amount, ...dynamicStyle }}
      >
        <div className="flex flex-column justify-content-center align-items-start w-full p-3">
          <h6 className="m-0 p-0 fw-bold text-xs">-</h6>
        </div>
      </div>

      {/* Action Button */}
      <div
        className="flex justify-content-center align-items-center border-left-1 border-200"
        style={{ ...widthStyle.action, ...dynamicStyle }}
      >
        <div className="flex flex-row justify-content-center align-items-center px-3 w-full">
          <Button button="btn-primary btn-sm p-0" title="+" onClick={handleAdd}></Button>
        </div>
      </div>
    </>
  );
}

export default TableFormNewField;
